import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastr: ToastrService) {}
  showSuccess(message: string, title?: string) {
    this.toastr.success(message, title, {
      toastClass: 'custom-toast success-toast',
      timeOut: 5000, // Close after 5 seconds
      closeButton: true
    });
  }

  showError(message: string, title?: string) {
    this.toastr.error(message, title, {
      toastClass: 'custom-toast error-toast',
      timeOut: 0, // Prevent auto close
      extendedTimeOut: 0, // Prevent auto close on hover
      closeButton: true // Close on user click
    });
  }

  showInfo(message: string, title?: string) {
    this.toastr.info(message, title, {
      toastClass: 'custom-toast info-toast',
      closeButton: true
    });
  }

  showWarning(message: string, title?: string) {
    this.toastr.warning(message, title, {
      toastClass: 'custom-toast warning-toast',
      closeButton: true
    });
  }

  showOnSuccessfulPlacingVote() {
    this.showSuccess("Your vote has been submitted. Thank you!", "Vote Successful");
  }

  showOnFailedPlacingVote() {
    this.showError("Your vote was not placed due to an unexpected error. Please try again or contact IT Support if issue persists.", "Vote Failed");
  }

  clearToasts() {
    this.toastr.clear();
  }

}
